import { useEffect, useState } from 'react'
import api, { IBuildingTypeWithCompany } from '@api'

interface IState {
  buildingType: IBuildingTypeWithCompany
  isLoading: boolean
  updateBuildingType: (buildingType: IBuildingTypeWithCompany) => void
}

export default function useBuilding(id?: string): IState {
  const [isLoading, setIsLoading] = useState(true)
  const [buildingType, setBuildingType] = useState<IBuildingTypeWithCompany>({
    id: '',
    name: '',
    displayName: '',
    company: null,
  })

  useEffect(() => {
    if (id) {
      api.building.buildingType.details(id).then((bt: IBuildingTypeWithCompany) => {
        setIsLoading(false)
        setBuildingType(bt)
      })
    }
  }, [id])

  return {
    buildingType,
    isLoading,
    updateBuildingType: (bt) => setBuildingType(bt),
  }
}
